"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var classNames = require("classnames");
var react_tracking_1 = require("react-tracking");
var bind_1 = require("../../../bind");
var lowlight_1 = require("./lowlight");
var price_display_1 = require("@reverbdotcom/commons/dist/components/price_display");
var money_1 = require("@reverbdotcom/commons/dist/money");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var COMPONENT_NAME = 'CspCompletionCard';
var CspCompletionCard = /** @class */ (function (_super) {
    tslib_1.__extends(CspCompletionCard, _super);
    function CspCompletionCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CspCompletionCard.prototype, "option", {
        get: function () {
            return this.props.suggestion.completion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "inventoryNew", {
        get: function () {
            return this.option.completionPayload.inventoryNew;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "inventoryUsed", {
        get: function () {
            return this.option.completionPayload.inventoryUsed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "listingTotal", {
        get: function () {
            return this.inventoryUsed.listingCount + this.inventoryNew.listingCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "minPriceNew", {
        get: function () {
            return this.option.completionPayload.inventoryNew.listingMinPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "minPriceUsed", {
        get: function () {
            return this.option.completionPayload.inventoryUsed.listingMinPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "hasNoListings", {
        get: function () {
            return this.listingTotal === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "hasOnlyNewListings", {
        get: function () {
            return !this.inventoryUsed.listingCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "hasOnlyUsedListings", {
        get: function () {
            return !this.inventoryNew.listingCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "minPrice", {
        get: function () {
            if (this.hasNoListings)
                return null;
            if (this.hasOnlyNewListings)
                return this.minPriceNew;
            if (this.hasOnlyUsedListings)
                return this.minPriceUsed;
            if (this.minPriceUsed.cents < this.minPriceNew.cents)
                return this.minPriceUsed;
            return this.minPriceNew;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CspCompletionCard.prototype, "minPriceDisplay", {
        get: function () {
            var money = { amountCents: this.minPrice.cents, currency: this.minPrice.currency };
            return money_1.formatAmountCents(money);
        },
        enumerable: true,
        configurable: true
    });
    CspCompletionCard.prototype.submitSelection = function (e) {
        e.preventDefault();
        this.props.selectSuggestion(this.props.suggestion);
    };
    CspCompletionCard.prototype.renderTitle = function () {
        var title = lowlight_1.default({
            input: this.props.lastTypedValue,
            output: this.option.output,
            emphasize: function (idx, em) { return React.createElement(React.Fragment, { key: idx },
                em.pre,
                React.createElement("b", null, em.word),
                em.post,
                " "); },
            noop: function (idx, em) { return React.createElement(React.Fragment, { key: idx },
                em.word,
                " "); },
        });
        return (React.createElement("div", { className: "csp__suggestion__title" }, title));
    };
    CspCompletionCard.prototype.renderImage = function () {
        var image = this.option.completionPayload.thumbnailUrl;
        return (React.createElement("div", { className: "csp__suggestion__image" },
            React.createElement("div", { className: "csp__suggestion__image__inner" },
                React.createElement("img", { src: image, alt: this.option.output }))));
    };
    CspCompletionCard.prototype.renderPrices = function () {
        var minPrice = this.minPrice;
        if (!minPrice || !minPrice.cents)
            return null;
        return (React.createElement("div", { className: "csp__suggestion__prices" },
            I18n.t('discovery.siteSearch.cspCompletionCard.availableFrom', { count: this.listingTotal }),
            React.createElement("span", { className: "csp__suggestion__prices__price" },
                React.createElement(price_display_1.default, { amountCents: minPrice.cents, currency: minPrice.currency, display: this.minPriceDisplay }))));
    };
    CspCompletionCard.prototype.render = function () {
        if (!this.option)
            return null;
        if (this.hasNoListings)
            return null;
        var classes = classNames('site-search__dropdown__section__item', 'site-search__dropdown__section__item--csp', { 'site-search__dropdown__section__item--selected': this.props.active });
        return (React.createElement("div", { key: this.option.id, className: classes },
            React.createElement("a", { onClick: this.submitSelection },
                React.createElement("div", { className: "csp__suggestion" },
                    this.renderImage(),
                    React.createElement("div", { className: "csp__suggestion__content" },
                        this.renderTitle(),
                        this.renderPrices())))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CspCompletionCard.prototype, "submitSelection", null);
    CspCompletionCard = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME, type: tracker_1.CSP_TYPE })
    ], CspCompletionCard);
    return CspCompletionCard;
}(React.Component));
exports.default = CspCompletionCard;
//# sourceMappingURL=csp_completion_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/csp_completion_card.js
// module id = mAUI
// module chunks = 20 21